const Color = {
  BLACK: '#000',
  WHITE: '#fff'
}

export default Color;
